import { Remove } from '@td-client-frontend/icons';
import React from 'react';

interface Props {
  values: any;
  organizationsList: any;
  removeRelation: (dataObject: any) => void;
}

export const OrganizationAndRolesList = ({ values, organizationsList, removeRelation }: Props) => {
  return (
    <div className="my-2 font-normal">
      <div className="grid uppercase text-gray-30" style={{ gridTemplateColumns: '250px 1fr' }}>
        <span>Organization</span>
        <span>Role</span>
      </div>

      {organizationsList.map(({ context, role }: any, index: number) => (
        <div
          className="grid items-center py-2 border-b"
          style={{ gridTemplateColumns: '250px 1fr auto' }}
          key={`${context.contextType}/${context.id}/${index}`}
        >
          <span>{context.name || 'Global'}</span>
          <span>{role.roleNm}</span>

          <Remove
            fill="#000"
            className="mx-3 cursor-pointer"
            onClick={() =>
              removeRelation({
                values,
                context,
                role
              })
            }
          />
        </div>
      ))}
    </div>
  );
};
